<template>
  <Grid gaf="column" justify-content="start" align-content="center" gap="var(--r-space-sm)">
    <RChip
      v-for="filter of availableFilters"
      :key="filter.value"
      :active="chipFilters.includes(filter.value)"
      @click="changeChipFilters(filter.value)"
    >
      {{ filter.label }}
    </RChip>

    <RChip :active="!chipFilters.length" @click="setTableStateChipFilter([])">all periods</RChip>
  </Grid>
</template>

<script>
// Libraries
import { mapState } from 'vuex'
// Components
import RChip from '@/ui/RChip'

export default {
  components: {
    RChip
  },

  data: () => ({
    availableFilters: [
      { label: 'active', value: 'current' },
      { label: 'inactive', value: 'inactive' },
      { label: 'future', value: 'future' },
      { label: 'one time purchase', value: 'oneTimePurchase' }
    ]
  }),

  computed: {
    ...mapState('lv-subscriptions', ['editMode']),

    chipFilters() {
      if (this.editMode) return this.$store.state['lv-subscriptions-edit-mode'].tableState.chipFilter
      return this.$store.state['lv-subscriptions'].tableState.chipFilter
    }
  },

  methods: {
    changeChipFilters(chipFilter) {
      if (this.editMode) this.$store.commit('lv-subscriptions-edit-mode/changeChipFilters', chipFilter)
      else this.$store.commit('lv-subscriptions/changeChipFilters', chipFilter)
    },

    setTableStateChipFilter() {
      if (this.editMode) this.$store.commit('lv-subscriptions-edit-mode/setTableStateChipFilter', [])
      else this.$store.commit('lv-subscriptions/setTableStateChipFilter', [])
    }
  }
}
</script>
